/**
 * Dataset Overview Card.
 * Displays high-level dataset statistics and quality score.
 */

import React from 'react';
import type { DatasetAnalysis } from '@excel-ai-studio/shared';
import { ResultCard } from '../common/ResultCard';

interface DatasetOverviewCardProps {
  readonly analysis: DatasetAnalysis;
}

export const DatasetOverviewCard: React.FC<DatasetOverviewCardProps> = ({ analysis }) => {
  const qualityColor = analysis.qualityScore
    ? analysis.qualityScore >= 80
      ? 'success'
      : analysis.qualityScore >= 60
        ? 'warning'
        : 'error'
    : 'default';

  return (
    <ResultCard
      title="Vue d'ensemble du dataset"
      variant="analysis"
    >
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
        <div>
          <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>Lignes</div>
          <div style={{ fontSize: '20px', fontWeight: 'bold' }}>{analysis.rowCount.toLocaleString()}</div>
        </div>
        <div>
          <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>Colonnes</div>
          <div style={{ fontSize: '20px', fontWeight: 'bold' }}>{analysis.columnCount}</div>
        </div>
        <div>
          <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>Types détectés</div>
          <div style={{ fontSize: '14px' }}>
            {analysis.numericColumns.length > 0 && <span>📊 {analysis.numericColumns.length} num. </span>}
            {analysis.categoricalColumns.length > 0 && <span>🏷️ {analysis.categoricalColumns.length} cat. </span>}
            {analysis.dateColumns.length > 0 && <span>📅 {analysis.dateColumns.length} date </span>}
            {analysis.textColumns.length > 0 && <span>📝 {analysis.textColumns.length} texte</span>}
          </div>
        </div>
        {analysis.qualityScore !== undefined && (
          <div>
            <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>Score qualité</div>
            <div style={{ fontSize: '20px', fontWeight: 'bold', color: qualityColor === 'success' ? '#107c10' : qualityColor === 'warning' ? '#ffb900' : '#d13438' }}>
              {analysis.qualityScore}/100
            </div>
          </div>
        )}
      </div>
    </ResultCard>
  );
};
